<footer class="newsletter-footer d-flex justify-content-center align-items-center gap-3 py-3">
  <a
    class="newsletter-footer__link"
    href="https://www.bmw.de/de/footer/metanavigation/legal-notice-pool/imprint.html"
    target="_blank"
    >{{ 'footer.links.imprint' | translate }}</a
  >
  <a class="newsletter-footer__link" href="/newsletter/data-protection" target="_blank">{{
    'footer.links.privacy_policy' | translate
  }}</a>
  <a
    class="newsletter-footer__link"
    href="https://www.bmw.de/de/footer/metanavigation/legal-disclaimer-pool/legal-disclaimer.html"
    target="_blank"
    >{{ 'footer.links.legal_notice' | translate }}</a
  >
  <a class="newsletter-footer__link" href="/newsletter/cookie-policy">{{ 'footer.links.cookies' | translate }}</a>
</footer>
